import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense';

const WorkQueueEdit = withSuspense(lazy(() => import('./WorkQueueEdit.jsx')));

export default WorkQueueEdit;
